import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Typography,
} from '@mui/material'

import { Circle, Close } from '@mui/icons-material'
import {
  AccountStatusEnum,
  AccountStatusReasonsEnum,
  DialogsEnum,
} from '@/enums'
import useDialog from '@/hooks/ui/use-dialog.hook'

import { usePlayerAccountStatusForm } from '@/views/player-card/hooks'
import InputFormikField from '@/views/components/input-formik-field/index.component'
import { AccountStatusData } from '@/constants/player-card'

export const DialogAccountStatusForm = () => {
  const { t } = useTranslation()
  const { dialog, handleCloseDialog } = useDialog()
  const { formikAccountStatus, handleSubmit } = usePlayerAccountStatusForm()

  return (
    <Dialog
      open={dialog.open && dialog.id === DialogsEnum.DIALOG_EDIT_ACCOUNT_STATUS}
      aria-labelledby="dialog-title"
      fullWidth
      sx={{
        '& .MuiDialog-paperFullWidth': {
          width: '600px',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle id="dialog-title">
        <Box mb={1} display="flex" justifyContent="space-between" width="100%">
          <Typography fontWeight={700} variant="h5" sx={{ mt: 0.5, pl: 1 }}>
            {t('playerCard.accountStatus')}
          </Typography>
          <Box display="flex" alignItems="center">
            <IconButton onClick={handleCloseDialog}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <FormikProvider value={formikAccountStatus}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputFormikField
                label={t('playerCard.accountStatus')}
                name="accountStatus"
                select
              >
                {Object.values(AccountStatusEnum)
                  .filter((status) => status !== AccountStatusEnum.INACTIVE)
                  .map((status) => {
                    return (
                      <MenuItem key={status} value={status}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 10,
                            gap: 1,
                          }}
                        >
                          <Circle
                            className={AccountStatusData[status].color}
                            fontSize="inherit"
                          />
                          <Typography variant="body2" sx={{ paddingLeft: 0.5 }}>
                            {t(`${AccountStatusData[status].label}`)}
                          </Typography>
                        </Box>
                      </MenuItem>
                    )
                  })}
              </InputFormikField>
            </Grid>
            {formikAccountStatus.values.accountStatus ===
              AccountStatusEnum.BLOCKED && (
              <Grid item xs={12}>
                <InputFormikField
                  label={t('playerCard.blockedReasons')}
                  name="accountStatusReason"
                  select
                >
                  {Object.values(AccountStatusReasonsEnum).map((reason) => {
                    return (
                      <MenuItem key={reason} value={reason}>
                        <Typography variant="body2" sx={{ paddingLeft: 0.5 }}>
                          {t(`accountStatusReasonsOptions.${reason}`)}
                        </Typography>
                      </MenuItem>
                    )
                  })}
                </InputFormikField>
              </Grid>
            )}
            <Grid item xs={12}>
              <InputFormikField label={t('labels.comment')} name="comment" />
            </Grid>
          </Grid>
        </FormikProvider>
        <DialogActions sx={{ padding: '10px 0px' }}>
          <Button onClick={handleCloseDialog} className="red">
            {t('labels.cancel')}
          </Button>
          <Button
            disabled={
              !(formikAccountStatus.isValid && formikAccountStatus.dirty)
            }
            variant="contained"
            onClick={handleSubmit}
          >
            {t('labels.update')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
